/* ============================================================
   <product-card-quick-add> — adds a single variant to cart via AJAX.
   Dawn-style: optimistic UI, error fallback, fires cart:updated.
   ============================================================ */

(function () {
  'use strict';

  if (window.customElements && window.customElements.get('product-card-quick-add')) return;

  class ProductCardQuickAdd extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      var btn = event.target.closest('.product-cart-btn');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();

      var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      if (!window.Moonrise || !window.Moonrise.cart) {
        // Cart store hasn't loaded — fall back to product page link
        var handle = this.getAttribute('data-product-handle');
        if (handle) window.location.href = '/products/' + handle;
        return;
      }

      btn.disabled = true;
      btn.classList.add('is-loading');

      window.Moonrise.cart.add(variantId, 1)
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
          btn.disabled = false;

          if (window.Moonrise.openCartDrawer) {
            window.Moonrise.openCartDrawer();
          }
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 2400);
          btn.disabled = false;
          console.error('Quick-add failed:', err);
        });
    }
  }

  window.customElements.define('product-card-quick-add', ProductCardQuickAdd);
})();
